import { PlayerEnvironment } from './player_environment';

export default class PlayerMobileBitrate {
  constructor({ tech, data } = {}) {
    this._data = data;
    this._tech = tech;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  isDrm() {
    return this.data().drmEnabled();
  }

  representations() {
    if (this.isDrm()) {
      return this.tech().plugin().dashObject().representations();
    } else {
      return this.tech().plugin().hlsObject().hls().representations();
    }
  }

  isSafari() {
    return PlayerEnvironment.browserName().toLowerCase().includes('safari');
  }

  init() {
    if(this.isSafari()) return;

    this.tech().on('loadedmetadata', () => {
      this.enableLowestBitrate();
      this.enableAutoBitrateAfter10s();
    });
  }

  enableLowestBitrate() {
    if (this.isDrm()) {
      this.setDashLowestBitrate();
    } else {
      this.setHlsLowestBitrate();
    }
  }

  enableAutoBitrateAfter10s() {
    window.setTimeout(() => {
      if (this.isDrm()) {
        this.enableDashAutoBitrate();
      } else {
        this.enableAllHlsBitrates();
      }
    }, 10000);
  }

  enableAllHlsBitrates() {
    this.representations().forEach((representation) => {
      representation.enabled(true);
    });
  }

  enableDashAutoBitrate() {
    this.tech().plugin().dashObject().enableAutoSwitchQuality();
  }

  setHlsLowestBitrate() {
    this.enableAllHlsBitrates();
    this.representations().forEach((representation, index) => {
      if (index !== 0) {
        representation.enabled(false);
      }
    });
  }

  setDashLowestBitrate() {
    this.representations().forEach((representation) => {
      if (representation.qualityIndex == 0) {
        representation.enable();
      }
    });
  }
}
